import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const ChangeBatteryLegendComponent = () => (
    <div>
        <div style={{ padding: '10px' }}>
            <small>{t`Кол-во переходов CHANGE_BATTERY`}:</small>
        </div>
        <div className={styles.circlesbox}>
            <div className={styles.circleCurScootersParking_0}></div>
            <div className={styles.circleCurScootersParking_1}></div>
            <div className={styles.circleCurScootersParking_2}></div>
            <div className={styles.circleCurScootersParking_3}></div>
        </div>
        <div className={styles.curScootersLegendContainer}>
            <div className={`${styles.curScootersLegendItem} ${styles.curScootersLegendItem_dark}`}>0 </div>
            <div className={`${styles.curScootersLegendItem} ${styles.curScootersLegendItem_light}`}>  2</div>
            <div className={`${styles.curScootersLegendItem} ${styles.curScootersLegendItem_light}`}>~10</div>
            <div className={`${styles.curScootersLegendItem} ${styles.curScootersLegendItem_light}`}>&gt; 50</div>
        </div>
        <div style={{ padding: '10px' }}>
            <small>{t`Чем краснее и больше круг, тем больше переходов CHANGE-BATTERY на парковке`}</small>
        </div>
    </div>
);

export const ChangeBatteryLegend = withDisplayedLayersCheck(
    ChangeBatteryLegendComponent,
    t`Среднесуточное количество переходов в CHANGE_BATTERY по парковкам`
);
